export type NationalityOption = {
  /** Demonym shown to the user, e.g. "Indian". */
  label: string;
  /** ISO 3166-1 alpha-2 country code persisted on the staff record, e.g. "IN". */
  value: string;
};

/** Demonyms keyed by ISO 3166-1 alpha-2 code, sorted by label. */
export const NATIONALITY_OPTIONS: NationalityOption[] = [
  { label: "Afghan", value: "AF" },
  { label: "Albanian", value: "AL" },
  { label: "Algerian", value: "DZ" },
  { label: "American", value: "US" },
  { label: "Andorran", value: "AD" },
  { label: "Angolan", value: "AO" },
  { label: "Antiguan and Barbudan", value: "AG" },
  { label: "Argentine", value: "AR" },
  { label: "Armenian", value: "AM" },
  { label: "Australian", value: "AU" },
  { label: "Austrian", value: "AT" },
  { label: "Azerbaijani", value: "AZ" },
  { label: "Bahamian", value: "BS" },
  { label: "Bahraini", value: "BH" },
  { label: "Bangladeshi", value: "BD" },
  { label: "Barbadian", value: "BB" },
  { label: "Basotho", value: "LS" },
  { label: "Belarusian", value: "BY" },
  { label: "Belgian", value: "BE" },
  { label: "Belizean", value: "BZ" },
  { label: "Beninese", value: "BJ" },
  { label: "Bhutanese", value: "BT" },
  { label: "Bolivian", value: "BO" },
  { label: "Bosnian and Herzegovinian", value: "BA" },
  { label: "Botswanan", value: "BW" },
  { label: "Brazilian", value: "BR" },
  { label: "British", value: "GB" },
  { label: "Bruneian", value: "BN" },
  { label: "Bulgarian", value: "BG" },
  { label: "Burkinabé", value: "BF" },
  { label: "Burmese", value: "MM" },
  { label: "Burundian", value: "BI" },
  { label: "Cabo Verdean", value: "CV" },
  { label: "Cambodian", value: "KH" },
  { label: "Cameroonian", value: "CM" },
  { label: "Canadian", value: "CA" },
  { label: "Central African", value: "CF" },
  { label: "Chadian", value: "TD" },
  { label: "Chilean", value: "CL" },
  { label: "Chinese", value: "CN" },
  { label: "Colombian", value: "CO" },
  { label: "Comoran", value: "KM" },
  { label: "Congolese (DR Congo)", value: "CD" },
  { label: "Congolese (Republic)", value: "CG" },
  { label: "Costa Rican", value: "CR" },
  { label: "Croatian", value: "HR" },
  { label: "Cuban", value: "CU" },
  { label: "Cypriot", value: "CY" },
  { label: "Czech", value: "CZ" },
  { label: "Danish", value: "DK" },
  { label: "Djiboutian", value: "DJ" },
  { label: "Dominican (Dominica)", value: "DM" },
  { label: "Dominican (Dominican Republic)", value: "DO" },
  { label: "Dutch", value: "NL" },
  { label: "East Timorese", value: "TL" },
  { label: "Ecuadorian", value: "EC" },
  { label: "Egyptian", value: "EG" },
  { label: "Emirati", value: "AE" },
  { label: "Equatorial Guinean", value: "GQ" },
  { label: "Eritrean", value: "ER" },
  { label: "Estonian", value: "EE" },
  { label: "Eswatini", value: "SZ" },
  { label: "Ethiopian", value: "ET" },
  { label: "Fijian", value: "FJ" },
  { label: "Filipino", value: "PH" },
  { label: "Finnish", value: "FI" },
  { label: "French", value: "FR" },
  { label: "Gabonese", value: "GA" },
  { label: "Gambian", value: "GM" },
  { label: "Georgian", value: "GE" },
  { label: "German", value: "DE" },
  { label: "Ghanaian", value: "GH" },
  { label: "Greek", value: "GR" },
  { label: "Grenadian", value: "GD" },
  { label: "Guatemalan", value: "GT" },
  { label: "Guinea-Bissauan", value: "GW" },
  { label: "Guinean", value: "GN" },
  { label: "Guyanese", value: "GY" },
  { label: "Haitian", value: "HT" },
  { label: "Honduran", value: "HN" },
  { label: "Hong Konger", value: "HK" },
  { label: "Hungarian", value: "HU" },
  { label: "Icelandic", value: "IS" },
  { label: "Indian", value: "IN" },
  { label: "Indonesian", value: "ID" },
  { label: "Iranian", value: "IR" },
  { label: "Iraqi", value: "IQ" },
  { label: "Irish", value: "IE" },
  { label: "Israeli", value: "IL" },
  { label: "Italian", value: "IT" },
  { label: "Ivorian", value: "CI" },
  { label: "Jamaican", value: "JM" },
  { label: "Japanese", value: "JP" },
  { label: "Jordanian", value: "JO" },
  { label: "Kazakhstani", value: "KZ" },
  { label: "Kenyan", value: "KE" },
  { label: "Kiribati", value: "KI" },
  { label: "Kosovar", value: "XK" },
  { label: "Kuwaiti", value: "KW" },
  { label: "Kyrgyzstani", value: "KG" },
  { label: "Laotian", value: "LA" },
  { label: "Latvian", value: "LV" },
  { label: "Lebanese", value: "LB" },
  { label: "Liberian", value: "LR" },
  { label: "Libyan", value: "LY" },
  { label: "Liechtensteiner", value: "LI" },
  { label: "Lithuanian", value: "LT" },
  { label: "Luxembourgish", value: "LU" },
  { label: "Macanese", value: "MO" },
  { label: "Malagasy", value: "MG" },
  { label: "Malawian", value: "MW" },
  { label: "Malaysian", value: "MY" },
  { label: "Maldivian", value: "MV" },
  { label: "Malian", value: "ML" },
  { label: "Maltese", value: "MT" },
  { label: "Marshallese", value: "MH" },
  { label: "Mauritanian", value: "MR" },
  { label: "Mauritian", value: "MU" },
  { label: "Mexican", value: "MX" },
  { label: "Micronesian", value: "FM" },
  { label: "Moldovan", value: "MD" },
  { label: "Monégasque", value: "MC" },
  { label: "Mongolian", value: "MN" },
  { label: "Montenegrin", value: "ME" },
  { label: "Moroccan", value: "MA" },
  { label: "Mozambican", value: "MZ" },
  { label: "Namibian", value: "NA" },
  { label: "Nauruan", value: "NR" },
  { label: "Nepali", value: "NP" },
  { label: "New Zealander", value: "NZ" },
  { label: "Nicaraguan", value: "NI" },
  { label: "Nigerian", value: "NG" },
  { label: "Nigerien", value: "NE" },
  { label: "North Korean", value: "KP" },
  { label: "North Macedonian", value: "MK" },
  { label: "Norwegian", value: "NO" },
  { label: "Omani", value: "OM" },
  { label: "Pakistani", value: "PK" },
  { label: "Palauan", value: "PW" },
  { label: "Palestinian", value: "PS" },
  { label: "Panamanian", value: "PA" },
  { label: "Papua New Guinean", value: "PG" },
  { label: "Paraguayan", value: "PY" },
  { label: "Peruvian", value: "PE" },
  { label: "Polish", value: "PL" },
  { label: "Portuguese", value: "PT" },
  { label: "Puerto Rican", value: "PR" },
  { label: "Qatari", value: "QA" },
  { label: "Romanian", value: "RO" },
  { label: "Russian", value: "RU" },
  { label: "Rwandan", value: "RW" },
  { label: "Saint Kitts and Nevis", value: "KN" },
  { label: "Saint Lucian", value: "LC" },
  { label: "Saint Vincentian", value: "VC" },
  { label: "Salvadoran", value: "SV" },
  { label: "Samoan", value: "WS" },
  { label: "San Marinese", value: "SM" },
  { label: "São Toméan", value: "ST" },
  { label: "Saudi", value: "SA" },
  { label: "Senegalese", value: "SN" },
  { label: "Serbian", value: "RS" },
  { label: "Seychellois", value: "SC" },
  { label: "Sierra Leonean", value: "SL" },
  { label: "Singaporean", value: "SG" },
  { label: "Slovak", value: "SK" },
  { label: "Slovenian", value: "SI" },
  { label: "Solomon Islander", value: "SB" },
  { label: "Somali", value: "SO" },
  { label: "South African", value: "ZA" },
  { label: "South Korean", value: "KR" },
  { label: "South Sudanese", value: "SS" },
  { label: "Spanish", value: "ES" },
  { label: "Sri Lankan", value: "LK" },
  { label: "Sudanese", value: "SD" },
  { label: "Surinamese", value: "SR" },
  { label: "Swedish", value: "SE" },
  { label: "Swiss", value: "CH" },
  { label: "Syrian", value: "SY" },
  { label: "Taiwanese", value: "TW" },
  { label: "Tajikistani", value: "TJ" },
  { label: "Tanzanian", value: "TZ" },
  { label: "Thai", value: "TH" },
  { label: "Togolese", value: "TG" },
  { label: "Tongan", value: "TO" },
  { label: "Trinidadian and Tobagonian", value: "TT" },
  { label: "Tunisian", value: "TN" },
  { label: "Turkish", value: "TR" },
  { label: "Turkmen", value: "TM" },
  { label: "Tuvaluan", value: "TV" },
  { label: "Ugandan", value: "UG" },
  { label: "Ukrainian", value: "UA" },
  { label: "Uruguayan", value: "UY" },
  { label: "Uzbekistani", value: "UZ" },
  { label: "Vanuatuan", value: "VU" },
  { label: "Vatican", value: "VA" },
  { label: "Venezuelan", value: "VE" },
  { label: "Vietnamese", value: "VN" },
  { label: "Yemeni", value: "YE" },
  { label: "Zambian", value: "ZM" },
  { label: "Zimbabwean", value: "ZW" },
];
